<header class="h-12 flex flex-row gap-4 px-4 items-center">
  @if (!responsiveService.isMobile()) {
    <i
      class="pi pi-bars text-2xl hover:cursor-pointer text-contrast"
      tabindex="0"
      role="button"
      (click)="sidebarService.toggle()"
      (keyup.enter)="sidebarService.toggle()"
    ></i>
  }
  <img
    [ngSrc]="logoUrl"
    [alt]="'common.altText.mitsubishiLogo' | translate"
    class="hover:cursor-pointer"
    height="14"
    priority="true"
    routerLink="/home"
    width="76"
  />
  <p-menubar [model]="items" class="grow" breakpoint="1000px" />
  <mp-notification />
  <mp-settings-buttons />
  <mp-logout-button />
</header>
